// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ix5tWuUa1zjWSLRqV9S1 {
  height: 100%;
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 25px;
}

.qd_MFQEwJibiMb4CJnkA {
  margin: 0 auto;
  width: 75%;
}

.OUqhj24RrIsmx0yBiiir {
  width: 100px;
}

.OYkAHEX1GFyiqgw4a_Hz {
  font-size: 1rem;
  gap: 15px;
}

.OYkAHEX1GFyiqgw4a_Hz div {
  min-width: 30%;
}

.OYkAHEX1GFyiqgw4a_Hz p { 
  margin-bottom: 10px;
}

.aeb3dOYx67ihWDK2WA8v {
  display: flex;
  align-items: center;
  width: 50%;
  margin: 0 auto;
  gap: 15px;
  justify-content: center;
  flex-direction: column;
}

.aeb3dOYx67ihWDK2WA8v button {
  width: 225px;
}

@media screen and (max-width: 900px) {
  .qd_MFQEwJibiMb4CJnkA {
    width: 100%;
    font-size: 15px;
  }

  .OUqhj24RrIsmx0yBiiir {
    width: 35px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Views/MainMenu/index.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".menu {\n  height: 100%;\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 25px;\n}\n\n.content {\n  margin: 0 auto;\n  width: 75%;\n}\n\n.hero {\n  width: 100px;\n}\n\n.row {\n  font-size: 1rem;\n  gap: 15px;\n}\n\n.row div {\n  min-width: 30%;\n}\n\n.row p { \n  margin-bottom: 10px;\n}\n\n.buttons {\n  display: flex;\n  align-items: center;\n  width: 50%;\n  margin: 0 auto;\n  gap: 15px;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.buttons button {\n  width: 225px;\n}\n\n@media screen and (max-width: 900px) {\n  .content {\n    width: 100%;\n    font-size: 15px;\n  }\n\n  .hero {\n    width: 35px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `Ix5tWuUa1zjWSLRqV9S1`,
	"content": `qd_MFQEwJibiMb4CJnkA`,
	"hero": `OUqhj24RrIsmx0yBiiir`,
	"row": `OYkAHEX1GFyiqgw4a_Hz`,
	"buttons": `aeb3dOYx67ihWDK2WA8v`
};
export default ___CSS_LOADER_EXPORT___;
